import React from 'react';
import { TextField } from '@mui/material';
import { ApprovalAction, ACTION_TYPES } from '../constants';

interface RejectionReasonSectionProps {
  action: ApprovalAction;
  rejectionReason: string;
  onRejectionReasonChange: (reason: string) => void;
  isSubmitting: boolean;
  readOnly: boolean;
}

export const RejectionReasonSection: React.FC<RejectionReasonSectionProps> = ({
  action,
  rejectionReason,
  onRejectionReasonChange,
  isSubmitting,
  readOnly,
}) => {
  if (action !== ACTION_TYPES.REJECT) return null;

  const hasError = !rejectionReason.trim();

  return (
    <TextField
      label="Rejection Reason"
      value={rejectionReason}
      onChange={(e) => onRejectionReasonChange(e.target.value)}
      required={!readOnly}
      error={hasError && !readOnly}
      helperText={hasError && !readOnly ? 'Rejection reason is required' : ''}
      disabled={isSubmitting || readOnly}
      fullWidth
    />
  );
};

export default RejectionReasonSection;
